import React, { useState } from "react";

import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components/macro";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import { TemporaryBusinessesDialog } from "components/Business/TemporaryBusinesses";
import { RowCard } from "components/Card";
import TemporaryBusinessesToResolve, {
  useHasTemporaryBusinessWarnings,
} from "components/DeploymentSaleSummaries/TemporaryBusinessesToResolve";
import { Column, Row } from "components/Layout";
import TabSelector from "components/TabSelector";

import { useIsMobile } from "hooks";

import { getLivestockSaleId } from "lib/navigation";

const ScrollableRow = styled(Row)`
  overflow-x: scroll;
`;

// The Temporary Businesses tab of the Exceptions view, for Sale overviews that
// don't show the Exceptions view.
export const TemporaryBusinessWarnings = ({ className = undefined }) => {
  const isMobile = useIsMobile();
  const hasTemporaryBusinessWarnings = useHasTemporaryBusinessWarnings();
  // Held here so the dialog outlives the card, which goes once the last
  // Business is resolved.
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      {hasTemporaryBusinessWarnings && (
        <RowCard className={className} isMobile={isMobile}>
          <Column fullWidth>
            <ScrollableRow alignCenter>
              <FaIcon
                icon={faExclamationCircle}
                color="warning"
                style={{ marginLeft: 6 }}
              />
              {/* Not the first child any more, so override its tab spacing. */}
              <TabSelector selected color="gray40" style={{ marginLeft: 12 }}>
                Temporary Businesses
              </TabSelector>
            </ScrollableRow>
            <div>
              <TemporaryBusinessesToResolve
                onResolve={() => setIsDialogOpen(true)}
              />
            </div>
          </Column>
        </RowCard>
      )}
      {isDialogOpen && (
        <TemporaryBusinessesDialog
          livestockSaleId={getLivestockSaleId()}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  );
};
